import React, { useRef, useState } from 'react';
import './Testimonial.scss';
import TestimonialCard from './partials/TestimonialCard';
import Review1 from '../../assets/Review1.png';
import Review2 from '../../assets/Review2.png';
import Review3 from '../../assets/Review3.png';

const Testimonial = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const containerRef = useRef(null);

  const testimonials = [
    {
      name: 'Satyam Mishra',
      title: 'Table Tennis Coach',
      rating: 5,
      review: 'I used to struggle with organizing my PDF files, but this tool changed everything. The seamless merging and splitting features are a lifesaver!',
      image: Review1,
    },
    {
      name: 'Shivansh D.',
      title: 'Data Analyst',
      rating: 5,
      review: 'MyPDF made my workflow so much easier! The conversion tools are fast, reliable, and incredibly simple to use. I highly recommend it!',
      image: Review2,
      highlighted: true,
    },
    {
      name: 'Aditya P.',
      title: 'College student',
      rating: 5,
      review: 'Best PDF tool I have ever used! The user-friendly interface and multiple conversion options make managing documents effortless.',
      image: Review3
    },
  ];

  const handleScroll = () => {
    if (!containerRef.current) return;
    const scrollLeft = containerRef.current.scrollLeft;
    const width = containerRef.current.offsetWidth;
    const index = Math.round(scrollLeft / width);
    setCurrentIndex(index);
  };

  return (
    <div className="testimonial-section">
      <div className="section-header">
        <h2>Trusted by People Worldwide</h2>
        <p>Discover how our tools help people stay organized and efficient.</p>
      </div>
      <div
        className="testimonial-slider"
        ref={containerRef}
        onScroll={handleScroll}
      >
        {testimonials.map((testimonial, index) => (
          <TestimonialCard key={index} {...testimonial} />
        ))}
      </div>

      <div className="testimonial-dots">
        {testimonials.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentIndex ? 'active' : ''}`}
          />
        ))}
      </div>
      <div className="testimonial-grid">
        {testimonials.map((testimonial, index) => (
          <TestimonialCard key={index} {...testimonial} />
        ))}
      </div>
    </div>
  );
};

export default Testimonial;
